import GhHtmlElement from '@gudhub/gh-html-element';
import { conversationMixin }   from './mixins/conversationMixin.js';
import { dataFetchMixin }      from './mixins/dataFetchMixin.js';
import { messagingMixin }      from './mixins/messagingMixin.js';
import { subscriptionMixin }   from './mixins/subscriptionMixin.js';
import { renderingMixin }      from './mixins/renderingMixin.js';
import { interactionsMixin }   from './mixins/interactionsMixin.js';
import { composerMixin }       from './mixins/composerMixin.js';
import { attachmentsMixin }    from './mixins/attachmentsMixin.js';
import { discussedItemsMixin } from './mixins/discussedItemsMixin.js';
import { addPeopleMixin }      from './mixins/addPeopleMixin.js';
import { mentionMixin }        from './mixins/mentionMixin.js';
import { callMixin }           from './mixins/callMixin.js';

class GhDirectMessageChat extends GhHtmlElement {

    constructor() {
        super();
        this.handleEmitToUser = this.handleEmitToUser.bind(this);
        this.pendingAttachments = [];
        this.tuiEditor = null;
        this.pendingMentions = new Map();
    }

    async onInit() {
        this.getAttributes();

        await gudhub.ghconstructor.getInstance('avatar');

        this.toast = gudhub.ghconstructor.angularInjector.get('ghToastService');

        super.render(`<div class="chat_loader loader"><span></span></div>`);
    }

    getAttributes() {
        this.app_id = this.getAttribute('app-id');
        this.item_id = this.getAttribute('item-id');
        this.field_id = this.getAttribute('field-id');
    }

    disconnectedCallback() {
        this.unsubscribeFromConversation();
    }
}

Object.assign(GhDirectMessageChat.prototype,
    conversationMixin,
    dataFetchMixin,
    messagingMixin,
    subscriptionMixin,
    renderingMixin,
    interactionsMixin,
    composerMixin,
    attachmentsMixin,
    discussedItemsMixin,
    addPeopleMixin,
    mentionMixin,
    callMixin,
);

if(!customElements.get('gh-direct-message-chat')){
    customElements.define('gh-direct-message-chat', GhDirectMessageChat);
}
